// extracted by mini-css-extract-plugin
export default {"newsItem":"index_newsItem_i9A7w","zz":"index_zz_c-os0"};